<template>
    <v-card class="speaker-session-card elevation-0" v-bind:style="{paddingTop: session.sponsored_by ? '36px': '16px'}">
        <ProfileBadge 
            v-if="session.sponsored_by"
            isPin
            :pin="{icon: sponsoredStarIcon, text: sponsoredLabel}"
        />
        <div class="speaker-session-card__content">
            <p class="speaker-session-card__title mb-1" :style="{color: titleColor}">
                {{ session.events_agenda_text }}
            </p>
            <p class="speaker-session-card__event-title mb-2">
                <Icon 
                    type="events"
                    color="#8E8E93"
                    :size="14"
                    :pr="8"
                />
                <span class="speaker-session-card__event-text">
                    {{ session.event.event_title }}
                </span>
            </p>
            <p class="speaker-session-card__event-date mb-1" :style="{ color: titleColor }">
                {{ formatDateRange(session.events_agenda_from, session.events_agenda_to) }}
            </p>
            <div
                v-for="{ track_color, track_id, track_name } in session.tracks"
                :key="track_id"
                class="d-flex align-center mb-1"
                :style="`color: ${track_color}`"
            >
                <v-icon :color="track_color" dark size="10" style="margin: 0 3px;"> mdi-circle</v-icon>
                <span class="speaker-session-card__event-track ml-2">{{ track_name }}</span>
            </div>
            <p class="speaker-session-card__event-location mb-0" v-if="session.session_location">
                <Icon 
                    type="pin"
                    color="#9B9B9B"
                    :size="14"
                    :pr="8"
                />
                {{ session.session_location }}
            </p>
        </div>
        <v-btn 
            @click.prevent="toggleMyAgenda"
            class="speaker-session-card__add-agenda-btn elevation-0" 
            :loading="isSpeakerSessionLoading && speakerIdLoading === session.events_agenda_id"
        >
            <Icon 
                :type="scheduleIcon.icon"
                :color="scheduleIcon.color"
                :size="24"
            />
        </v-btn>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sponsoredStarIcon from '@/assets/images/icon-sponsored-star.svg'
import ProfileBadge from '@/components/ProfileBadge.vue'
export default {
    props: {
        session: {
            type: Object,
            default: () => {}
        },
        type: {
            type: String,
            default: ''
        }
    },
    components: {
        ProfileBadge
    },
    data() {
        return {
            sponsoredStarIcon
        }
    },
    methods: {
        ...mapActions('user', ['scheduleSession', 'unscheduleSession']),

        formatDateRange(dateFrom, dateTo) {
            const options = {
                weekday: 'long',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            }

            //Convert Unix timestamps to JavaScript Date objects
            const fromDate = new Date(dateFrom * 1000)
            const toDate = new Date(dateTo * 1000)

            // Format the dates
            const formattedFromDate = fromDate.toLocaleString('en-US', options)
            const formattedToDate = toDate.toLocaleTimeString('en-US', options)

            // Construct the formatted date range string
            return `${formattedFromDate} - ${formattedToDate}`
        },
        toggleMyAgenda() {
            if (!this.isSpeakerSessionLoading) {
                if (this.session.is_scheduled) {
                    this.unscheduleSession({id: this.session.events_agenda_id, type: this.type})
                } else {
                    this.scheduleSession({id: this.session.events_agenda_id, type: this.type})
                }
            }
        }
    },
    computed: {
        ...mapGetters('settings', ['styles']),
        ...mapGetters('user', ['speakerIdLoading', 'isSpeakerSessionLoading']),

        titleColor() {
            return this.type === 'future' ? '#4A4A4A' : '#9B9B9B'
        },
        scheduleIcon() {
            return this.session.is_scheduled ? { icon: 'calendar_check', color: '#9B9B9B' } : { icon: 'calendar_star', color: this.styles.button_main_background }
        },
        sponsoredLabel() {
            return this.session.sponsored_by ? `Sponsored by ${this.session.sponsored_by}` : ''
        },
    }
}
</script>

<style lang="scss">
.speaker-session-card {
    width: 100%;
    border-radius: 10px !important;
    padding: 16px;
    margin-bottom: 8px;
    background-color: #fff !important;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;

    &__title {
        font-size: 14px;
        font-weight: 700;
        line-height: 17px;
        overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
    }

    &__event {
        &-title {
            display: flex;
            align-items: center;
        }

        &-text {
            font-size: 14px;
            color: #4A4A4A;
            line-height: 20px;
        }

        &-date {
            font-size: 14px;
            font-weight: 600;
            line-height: 17px;
        }

        &-location {
            display: flex;
            align-items: center;
            color: #9B9B9B;
            font-size: 13px;
            font-weight: 600;
            line-height: 17px;
            word-break: break-word;
        }

        &-track {
            font-size: 13px;
            font-weight: 700;
            line-height: 15.85px;
        }
    }

    &__add-agenda-btn {
        align-self: center;
        background-color: transparent !important;
        padding: 0 8px !important;
        min-width: auto !important;
    }
}
</style>